module.exports = __webpack_public_path__ + "static/2-418ffa7a6aaf20d9dc8a749cb7ccd316.jpg";